function buildInnings(score, inning) {
  const balls = (score || []).filter(b => b.ing === inning).sort((a, b) => {
    if (a.oc !== b.oc) return a.oc - b.oc;
    return a.cid - b.cid;
  });
  if (!balls.length) return null;

  const teamName = balls[0]?.nat || (inning === 1 ? 'Team 1' : 'Team 2');
  const overs = {};
  balls.forEach(b => {
    if (!overs[b.oc]) overs[b.oc] = [];
    overs[b.oc].push(b);
  });

  let totalRuns = 0;
  let totalWkts = 0;
  const overRows = Object.keys(overs).sort((a, b) => a - b).map(oc => {
    const overBalls = overs[oc];
    const overRuns = overBalls.reduce((s, b) => s + (b.wkt ? 0 : b.run), 0);
    const overWkts = overBalls.filter(b => b.wkt).length;
    totalRuns += overRuns;
    totalWkts += overWkts;
    // Pad to 6 balls
    const padded = [...overBalls];
    while (padded.length < 6) padded.push(null);
    return { oc, balls: padded.slice(0, 6), overRuns, totalRuns, totalWkts };
  });

  return { teamName, overRows };
}

function BallCell({ ball }) {
  // ball nahi bowled -> khaali cell (reference: <td class="text-center"><!----></td>)
  if (!ball) return <td className="text-center"></td>;
  if (ball.wkt) return <td className="text-center"><span className="text-playerb">ww</span></td>;
  return <td className="text-center"><span>{ball.run}</span></td>;
}

function InningsTable({ data, label, first }) {
  if (!data) return null;
  return (
    <>
      <h4 className="mb-0">{label}</h4>
      <div className={`table-responsive${first ? ' mb-0' : ''}`}>
        <table className="table">
          <thead>
            <tr>
              <th className="text-center"><b><span className="text-success">{data.teamName}</span></b></th>
              <th className="text-center"><b>1</b></th>
              <th className="text-center"><b>2</b></th>
              <th className="text-center"><b>3</b></th>
              <th className="text-center"><b>4</b></th>
              <th className="text-center"><b>5</b></th>
              <th className="text-center"><b>6</b></th>
              <th className="text-center"><b>Run/Over</b></th>
              <th className="text-center"><b>Score</b></th>
            </tr>
          </thead>
          <tbody>
            {data.overRows.map(row => (
              <tr key={row.oc}>
                <td className="text-center"><b>Over {row.oc}</b></td>
                {row.balls.map((b, j) => <BallCell key={j} ball={b} />)}
                <td className="text-center nationcard">{row.overRuns}</td>
                <td className="text-center nationcard">{row.totalRuns}/{row.totalWkts}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}

export default function FiveCricketResult({ detail }) {
  const rdesc = detail?.rdesc || '';
  const winnat = detail?.winnat || '';
  const score = detail?.score || [];

  const inn1 = buildInnings(score, 1);
  const inn2 = buildInnings(score, 2);

  return (
    <div className="row row5 align-items-center five-cricket-result">
      <div className="col-12">
        <div className="text-right mt-3 score-head">
          Winner: <span className="text-success">{winnat}</span>
          {rdesc && <> | {rdesc}</>}
        </div>
        <InningsTable data={inn1} label="First Inning" first />
        <InningsTable data={inn2} label="Second Inning" />
      </div>
    </div>
  );
}
